import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var EmitterSize = /*#__PURE__*/function () {
  function EmitterSize() {
    _classCallCheck(this, EmitterSize);
    this.mode = "percent";
    this.height = 0;
    this.width = 0;
  }
  _createClass(EmitterSize, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.mode !== undefined) {
        this.mode = data.mode;
      }
      if (data.height !== undefined) {
        this.height = data.height;
      }
      if (data.width !== undefined) {
        this.width = data.width;
      }
    }
  }]);
  return EmitterSize;
}();